import { createApi } from '@reduxjs/toolkit/query/react';

import { IContactChannels } from '@/interfaces/contactChannel';

import { axiosBaseQuery } from './query';

export const contactsApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'contactsApi',
  endpoints(build) {
    return {
      getContacts: build.query<IContactChannels[], number | undefined>({
        query: courseId => ({
          formatResponse: response => response.data,
          url: `/learner/contacts/${courseId}`
        })
      })
    };
  }
});

export const { useGetContactsQuery } = contactsApi;
